// Mencegah dropdown antd tertutup saat user mengklik tooltip tur.
// antd (rc-trigger) mendeteksi "outside click" lewat listener `mousedown` capture di window
// dan menutup popup bila target bukan bagian dari popup. Tooltip react-joyride dirender di
// portal terpisah sehingga dianggap "luar" dan menutup dropdown.
//
// Kita pasang listener capture lebih awal (saat Module mount, sebelum dropdown pernah dibuka)
// supaya jalan duluan dari listener antd, lalu stopImmediatePropagation untuk klik yang berasal
// dari tooltip react-joyride selama `guard.active` true (di-set Module saat step ber-`keepDropdownOpen`).
const guard = { active: false }

let installed = false

export const installTourDropdownGuard = () => {
  if (installed || typeof window === 'undefined') {
    return
  }
  installed = true
  window.addEventListener(
    'mousedown',
    (event) => {
      if (!guard.active) {
        return
      }
      const { target } = event
      if (
        target &&
        typeof target.closest === 'function' &&
        target.closest('.react-joyride__floater')
      ) {
        event.stopImmediatePropagation()
      }
    },
    true,
  )
}

export default guard
